module.exports = __webpack_public_path__ + "static/media/help.59ce0013.svg";